import * as React from "react"
import { Navigation } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import 'swiper/scss'
import 'swiper/scss/navigation'

import * as styles from "./style.module.scss"

type Props = {
  images: string[],
  autoHeight: boolean,
  minHeight?: number
}

// markup
const FloorMapSlider = (props: Props) => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  React.useEffect(()=>{
    getActiveIndex
  }, [])

  const getActiveIndex = (swiper: any) => {
    setActiveIndex(swiper.activeIndex);
  }

  return (
    <div>
      <Swiper
        navigation={{
          nextEl: '#swiper-button-next',
          prevEl: '#swiper-button-prev'
        }}
        autoHeight={props.autoHeight}
        modules={[Navigation]}
        onSlideChangeTransitionEnd={getActiveIndex}
        style={{minHeight: props.minHeight || 0}}
      >
        {props.images.map(image => (
          <SwiperSlide key={image} style={{minHeight: props.minHeight || 0}}><img src={ image } alt="" /></SwiperSlide>
        ))}
      </Swiper>
      <div className={styles.buttons}>
        <div id="swiper-button-prev" className={activeIndex === 0 ? styles.buttonDisable : styles.button}><span></span></div>
        <div id="swiper-button-next" className={activeIndex === props.images.length - 1 ? styles.buttonDisable : styles.button}><span></span></div>
      </div>
    </div>
    
  )
}

export default FloorMapSlider
